<template>
    <div>
        <v-form ref="form" v-model="valid" data-cy="forgot-password-form" class="mb-6" @keyup.native.enter="submit">
            <v-text-field
                v-model.trim="email"
                :label="$t('email')"
                :placeholder="$t('enter_your_email')"
                :rules="validationRules('email', [emailRule, requiredRule])"
                type="email"
                variant="outlined"
                required
                data-cy="authorization-email-input"
            />
        </v-form>
        <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            class="mr-4"
            data-cy="forgot-password-button"
            @click="submit"
        >
            {{ $t('submit') }}
        </v-btn>
        <v-btn variant="outlined" color="primary" class="text-capitalize" @click="$emit('switch-to-login')">
            {{ $t('sign_in') }}?
        </v-btn>
    </div>
</template>

<script setup lang="ts">
    import {fullUrl} from '~src/utils/host-adapter'
    import {requiredRule, validationRules, emailRule} from '~/composables/rules'

    export interface Props {
        isB2b: boolean
    }
    const props = withDefaults(defineProps<Props>(), {
        isB2b: false,
    })
    const emit = defineEmits<{
        (e: 'forgot-password-success'): void
        (e: 'switch-to-login'): void
    }>()

    const app = useNuxtApp()
    const $toast = app.$toast
    const {t} = useI18n()

    const isLoading = ref<boolean>(false)
    const valid = ref<boolean>(false)
    const email = ref<string>(null)

    const submit = async (): Promise<void> => {
        if (!valid.value) return
        isLoading.value = true

        try {
            const rq = {
                email: email.value,
                redirectUrl: fullUrl('/restore-password'),
                clientName: document.title,
            }

            await restorePassword(rq)
            $toast.success(t('messages.success.forgot_password'))
            emit('forgot-password-success')
        } catch (e) {
            $toast.warning(e.msg || e.errors[0].message)
        } finally {
            isLoading.value = false
        }
    }

    const restorePassword = async (rq: any): Promise<void> => {
        if (props.isB2b) await app.$api.restoreB2BUserPasswordWithApiKey.post(rq)
        else await app.$api.restorePassword.post(rq)
    }
</script>
